import { WilliamsR as defaultOptions } from "./defaultOptionsForComputation";
import { isFiniteNumber } from "../utils";

export default function () {
  let options = defaultOptions;

  function calculator(data = []) {
    if (!Array.isArray(data) || data.length === 0) return [];

    const period = Math.max(
      1,
      Math.floor(options?.period ?? defaultOptions.period ?? 1),
    );
    const results = new Array(data.length).fill(undefined);

    const window = [];

    for (let i = 0; i < data.length; i += 1) {
      const datum = data[i] || {};
      const high = datum.high;
      const low = datum.low;
      const close = datum.close;

      if (
        !isFiniteNumber(high) ||
        !isFiniteNumber(low) ||
        !isFiniteNumber(close)
      ) {
        window.push({ high: undefined, low: undefined });
        if (window.length > period) window.shift();
        continue;
      }

      window.push({ high, low, close });
      if (window.length > period) window.shift();

      if (window.length === period) {
        let highestHigh = -Infinity;
        let lowestLow = Infinity;

        for (let j = 0; j < window.length; j += 1) {
          const entry = window[j];
          if (!isFiniteNumber(entry.high) || !isFiniteNumber(entry.low))
            continue;
          if (entry.high > highestHigh) highestHigh = entry.high;
          if (entry.low < lowestLow) lowestLow = entry.low;
        }

        const denominator = highestHigh - lowestLow;
        if (
          denominator !== 0 &&
          isFiniteNumber(window[window.length - 1].close)
        ) {
          results[i] =
            -100 *
            ((highestHigh - window[window.length - 1].close) / denominator);
        } else {
          results[i] = -100;
        }
      }
    }

    return results;
  }

  calculator.undefinedLength = function () {
    const period = Math.max(
      1,
      Math.floor(options?.period ?? defaultOptions.period ?? 1),
    );
    return period;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
